import script from "./SidebarView.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarView.vue?vue&type=script&setup=true&lang=js"

import "./SidebarView.vue?vue&type=style&index=0&id=c120a61a&lang=css"
import "./SidebarView.vue?vue&type=style&index=1&id=c120a61a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c120a61a"]])

export default __exports__